<a
  *ngIf="!isPublicContactUs() && !isSiteDown"
  class="login-header"
  data-test-id="lnk-contactus"
  (click)="contactUs()"
>
  Contact Us</a
>
